module.exports = __webpack_public_path__ + "media/images/product_lines/motorcycle/h2-3d2271590205cea803b51b433b148b5d.svg";